


















import { defineComponent, useRouter } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'

import { useProductStore } from '~/store/product'

import { useI18n } from '~/composables/i18n'
import { PRODUCT_STATUS } from '@/common/utils/product/constants'
import { DEVKEY } from '@/common/constants/cms'

export default defineComponent({
  setup() {
    const { t } = useI18n()
    // const router = useRouter()
    const { currentProduct } = useProductStore()

    const productStatus = currentProduct.data.attributes.statusDates.status
    const productId = currentProduct.data.key

    const isProductDiscontinued = productStatus === PRODUCT_STATUS.DISCONTINUED
    const isProductObsolete = productStatus === PRODUCT_STATUS.OBSOLETE

    const onInquiryButtonClick = () => {
      // TODO: revert this back once we don't use hybrid anymore
      // router.push('/learn-and-support/support-information/customer-support')
      window.location.href = '/learn-and-support/support-information/customer-support'
    }

    return {
      t,
      isProductDiscontinued,
      isProductObsolete,
      productId,
      onInquiryButtonClick,
      isEmpty,
      DEVKEY,
    }
  },
})
